<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-bullhorn"></span>Push Notification Broadcast</div>
    </div>

    <div class="content">

        <div class="margin-top-16">

            <div class="row margin-top-16">
                <div class="col-md-12">
                    <h4>Broadcast Information</h4>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !notification.title || notification.title.length===0}">
                    Push
                    Notification Subject:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <input type="text" pInputText placeholder="Enter the subject of the push notification"
                               [(ngModel)]="notification.title" maxlength="50"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !notification.title || notification.title.length===0}">
                    Push Notification Message:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
            <textarea type="text" pInputTextarea [autoResize]="true" class="p-fluid"
                      placeholder="Enter a push notification message information, Emojies allowed. Try to avoid line breaks as they don't render the text below the line break on certain views"
                      rows="5" [(ngModel)]="notification.message" maxlength="750"></textarea>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Send to Android Users:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <p-inputSwitch [(ngModel)]="notification.filters.android" binary="true"
                                       [ngModelOptions]="{standalone: true}">
                        </p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Send to iOS Users:
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <p-inputSwitch [(ngModel)]="notification.filters.iOS" binary="true"
                                       [ngModelOptions]="{standalone: true}">
                        </p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Send only to users who have not used the app in (days):
                </div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <input type="number" pInputText placeholder="Enter number of days"
                               [disabled]="notification.filters.usersWithNumberOfOpens && notification.filters.usersWithNumberOfOpens > 0"
                               [(ngModel)]="notification.filters.lastActivityAge"/>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Send only to users who have used the app more than (X) times:
                </div>
                <div class=" col-md-8">
                    <div class="p-inputgroup">
                        <input type="number" pInputText
                               placeholder="Enter number of times the user would have to have opened the app"
                               [disabled]="notification.filters.lastActivityAge && notification.filters.lastActivityAge > 0"
                               [(ngModel)]="notification.filters.usersWithNumberOfOpens"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-6"></div>
                <div class="col-md-3">
                    <button pButton type="button" class="p-button-raised full-width"
                            label="Send Preview To Me" (click)="sendPreview()"
                            [disabled]="sending || !valid()"></button>
                </div>
                <div class="col-md-3">
                    <button pButton type="button" class="p-button-raised approve full-width"
                            label="Send to Hubtiger User Base" (click)="sendBroadcast()"
                            [disabled]="sending || !valid()"></button>
                </div>
            </div>

        </div>
    </div>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
